<template>
  <div class="box" v-if="loading">
    <el-skeleton animated>
      <template slot="template">
        <el-skeleton-item variant="image" class="skeleton-image" />
        <div class="skeleton-content">
          <el-skeleton-item variant="text" class="skeleton-title" />
          <div class="skeleton-bottom">
            <el-skeleton-item variant="text" class="skeleton-icon" />
            <el-skeleton-item variant="text" class="skeleton-icon" />
          </div>
          <div class="skeleton-price">
            <el-skeleton-item variant="text" class="skeleton-room" />
            <el-skeleton-item variant="text" class="skeleton-price-text" />
          </div>
        </div>
      </template>
    </el-skeleton>
  </div>
  <div class="box" v-else-if="item" @click="handleClick">
    <div class="align-div">
      <!-- 图片部分：未加载完成时由 ProgressiveImage 自身显示骨架样式 -->
      <ProgressiveImage
        v-if="item"
        img-class="box-img house-img"
        :src="item.image"
        :alt="item.title"
        width="400"
        height="270"
        aspect-ratio="400/270"
        :fetchpriority="priority"
      />
      <div class="item-name">{{ item.title }}</div>
      <div class="item-bottom" v-if="isSale && item.city_en">
        <div class="icon" v-if="item.city_en">
          <ProgressiveImage img-class="icon-local" :src="localImg" alt="Location" /><span>{{
            item.city_en
          }}</span>
        </div>
        <div class="icon" v-if="item.home_type">
          <ProgressiveImage img-class="icon-house" :src="houseImg" alt="House type" /><span>{{
            item.home_type
          }}</span>
        </div>
      </div>
    </div>
    <div class="item-price">
      <div class="room-num-item">
        <div v-if="item.bedroom" class="room-num-item mr-4">
          <ProgressiveImage img-class="icon-bed mr-2" :src="chuangIcon" alt="Bedroom" />
          <span> × {{ item.bedroom }}</span>
        </div>
        <div v-if="item.toilet" class="room-num-item mr-4">
          <ProgressiveImage img-class="icon-bath mr-2" :src="bathrooms" alt="Bathroom" />
          <span> × {{ item.toilet }}</span>
        </div>
      </div>
      <template v-if="isSale">
        <div v-if="item.min" class="price">
          <span v-if="showFrom">from</span>£{{ item.min | formatThousandsSeparator }}
        </div>
      </template>
      <template v-else-if="isManagement">
        <div class="icon" v-if="item.city_en">
          <ProgressiveImage
            img-class="icon-location mr-2"
            :src="require('@images/setting/map-maker.png')"
          /><span>{{ item.city_en }}</span>
        </div>
      </template>
      <template v-else>
        <div v-if="item.city_en" class="icon">
          <ProgressiveImage img-class="icon-local mr-2" :src="localImg" alt="Location" /><span>{{
            item.city_en
          }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ProgressiveImage from '@/components/ProgressiveImage.vue';
import * as allIndex from '@/assets/images/index';
import { PAGE_MODE } from '@/components/components_const.js';

export default {
  name: 'CompHouseCard',
  components: {
    ProgressiveImage,
  },
  props: {
    item: {
      type: Object,
      required: false,
    },
    showFrom: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'sale', // 'sale' | 'management'
    },
    loading: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: String,
      default: 'low',
    },
  },
  data() {
    return {
      houseImg: allIndex.houseIcon,
      localImg: allIndex.localIcon,
      chuangIcon: allIndex.indexBedIcon,
      bathrooms: allIndex.indexIcon,
    };
  },
  methods: {
    handleClick() {
      this.$emit('click', this.item);
    },
  },
  filters: {
    formatThousandsSeparator(value) {
      if (!value) return '';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  computed: {
    isSale() {
      return this.mode === PAGE_MODE.SALE;
    },
    isManagement() {
      return this.mode === PAGE_MODE.MANAGEMENT;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 19.4rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 0.8rem;
  overflow: hidden !important;
  border: solid 0.05rem #e7e7e7;

  &:hover {
    border: solid 0.05rem var(--c-secondary);
    transform: translateY(-0.1rem);
    transition:
      background-color 0.3s,
      transform 0.3s ease-in-out;

    .item-price {
      background: var(--c-secondary);
    }
  }

  .align-div {
    .house-img {
      width: 100%;
      border-radius: 0 !important;
      background-color: #eee;
    }

    .item-name {
      font-family: PuHuiTiMedium;
      font-size: 1.1rem;
      color: #0f1d3d;
      padding: 0.6rem 0.6rem;
    }

    .item-bottom {
      display: flex;
      padding: 0 1.6rem 0.8rem 0.6rem;

      justify-content: space-between;
      color: $font;
      font-size: 0.8rem;
      font-family: PuHuiTiLight;
    }
    .icon {
      display: flex;
      align-items: center;

      ::v-deep img {
        margin-right: 0.4rem !important;
      }
    }
  }

  .item-price {
    padding: 0 1rem;
    height: 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f8f6;
    transition: background 0.3s;

    .price {
      font-family: PuHuiTiMedium;
      font-size: 1.2rem;

      span {
        font-size: 0.6rem;
        font-family: PuHuiTiLight;
        margin-right: 0.3rem;
      }
    }

    .room-num-item {
      display: flex;
      align-items: center;
      font-family: PuHuiTiLight;

      img {
        margin-right: 0.2rem;
      }
    }
  }
}

::v-deep .box-img {
  width: 19.4rem;
  height: 13.5rem;
  font-size: 0.6rem;
  border-radius: 0.5rem 0.5rem 0 0;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  aspect-ratio: 400/270;
}

::v-deep .icon-local {
  width: 1.15rem;
  height: 1.2rem;
}

::v-deep .icon-house {
  width: 1.18rem;
  height: 1.1rem;
}

::v-deep .icon-bed {
  width: 1rem;
  height: 0.9rem;
}

::v-deep .icon-bath {
  width: 0.95rem;
  height: 0.9rem;
}
::v-deep .icon-location {
  width: 1.1rem;
  height: 1.1rem;
}

.skeleton-image {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem 0.5rem 0 0;
}

.skeleton-content {
  padding: 0.6rem 0.6rem;
}

.skeleton-title {
  width: 80%;
  height: 1.1rem;
  margin-bottom: 0.6rem;
}

.skeleton-bottom {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.skeleton-icon {
  width: 40%;
  height: 0.8rem;
}

.skeleton-price {
  padding: 0 1rem;
  height: 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f8f6;
}

.skeleton-room {
  width: 50%;
  height: 0.9rem;
}

.skeleton-price-text {
  width: 20%;
  height: 1.2rem;
}

@media only screen and (max-width: 1024px) {
  .box {
    width: 48%;
    margin-bottom: 1.2rem;

    ::v-deep .box-img {
      width: 100%;
      height: 12rem;
      border-radius: 0.5rem 0.5rem 0 0;
    }

    .icon span {
      font-size: 0.6rem;
    }
  }

  .skeleton-image {
    width: 100%;
    height: 12rem;
    border-radius: 0.5rem 0.5rem 0 0;
  }
}
</style>
